// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"341":"6298d792","705":"527b2840","874":"b98a7bb7"}[chunkId] + ".js";
};